export default __webpack_public_path__ + "static/media/Olivias.24d12006.jpg";